import { Configuration, PopupRequest, RedirectRequest, SilentRequest, LogLevel } from '@azure/msal-browser';
import { getEnvVar } from '../utils/envConfig';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: getEnvVar('VITE_AZURE_CLIENT_ID'),
    authority: `https://login.microsoftonline.com/${getEnvVar('VITE_AZURE_TENANT_ID')}`,
    redirectUri: window.location.origin, // Dynamic redirect URI
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage', // Enables SSO across browser tabs
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge compatibility
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // Only log errors and warnings to reduce console noise
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL Error]:', message);
            return;
          case LogLevel.Warning:
            console.warn('[MSAL Warning]:', message);
            return;
          default:
            // Skip Info and Verbose logs
            return;
        }
      },
      logLevel: LogLevel.Warning // Only log warnings and errors
    }
  }
};

// API configuration for App Roles
export const apiConfig = {
  // For App Roles, we request the API's Application ID URI
  scopes: [`api://${getEnvVar('VITE_AZURE_API_CLIENT_ID')}/.default`],
  uri: getEnvVar('VITE_API_BASE_URL'),
};

// Login request configuration for App Roles
export const loginRequest: PopupRequest | RedirectRequest = {
  scopes: ['openid', 'profile', ...apiConfig.scopes], // Add openid and profile for proper ID token
  prompt: 'select_account',
};

// Token request configuration for silent token acquisition
export const tokenRequest: SilentRequest = {
  scopes: [...apiConfig.scopes],
  forceRefresh: false, // Set to true to skip cached tokens
};